import {Download, FileText, CheckCircle2} from 'lucide-react';

const catalogUrl = "https://static.lumi.new/80/803bb8da2431229e34c6462a96f79e77.pdf";

const highlights = [
"Linha completa de mangueiras hidráulicas e industriais",
"Conexões, terminais e adaptadores",
"Correias, pneumática e EPIs",
"Informações técnicas e tabelas de referência"];


export default function CatalogDownload() {
  return (
    <section
      id="catalogo"
      className="relative py-20 md:py-28 overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(rgba(13,27,62,0.92), rgba(13,27,62,0.95)), url('https://static.lumi.new/53/535c486b9c3cf0c8de9aaee0cef6635c.png')`,
        backgroundSize: "cover",
        backgroundPosition: "center"
      }}>

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Text content */}
          <div className="order-2 lg:order-1">
            <span className="inline-flex items-center gap-2 text-[#F5A623] font-bold uppercase tracking-widest text-sm mb-4">
              <FileText size={18} /> Catálogo Digital
            </span>
            <h2 className="text-4xl md:text-5xl font-black text-white uppercase font-barlow-condensed leading-tight">
              Baixe Nosso <span className="text-[#F5A623]">Catálogo</span> Completo
            </h2>
            <p className="mt-5 text-gray-300 text-lg leading-relaxed max-w-lg">
              Acesse toda a nossa linha de fornecimento em um só documento. Conheça produtos, especificações técnicas e soluções para o seu segmento.
            </p>

            <ul className="mt-8 space-y-3">
              {highlights.map((item) =>
              <li key={item} className="flex items-center gap-3 text-gray-200">
                  <CheckCircle2 size={20} className="text-[#F5A623] flex-shrink-0" />
                  <span className="text-base">{item}</span>
                </li>
              )}
            </ul>

            <a
              href={catalogUrl}
              target="_blank"
              rel="noopener noreferrer"
              download
              className="mt-9 inline-flex items-center gap-3 bg-[#F5A623] hover:bg-[#e0961a] text-[#0D1B3E] font-black px-9 py-4 rounded-lg uppercase tracking-wide transition-all duration-200 shadow-lg hover:shadow-xl hover:-translate-y-0.5">

              <Download size={22} /> Baixar Catálogo PDF
            </a>
          </div>

          {/* Hose image */}
          <div className="order-1 lg:order-2 flex justify-center items-center">
            <div className="relative w-full max-w-md">
              {/* Glow */}
              <div className="absolute inset-0 rounded-3xl bg-[#F5A623]/10 blur-2xl scale-95" />
              <img
                src="https://static.lumi.new/3c/3c69fc6056c796ab7d99eea47ecd4085.png"
                alt="Mangueira hidráulica Manguenela Rio"
                className="relative z-10 w-full rounded-3xl object-cover shadow-[0_30px_80px_-10px_rgba(0,0,0,0.6)] animate-float"
              />
              {/* Gold accent border */}
              <div className="absolute -bottom-3 -right-3 w-full h-full rounded-3xl border-2 border-[#F5A623]/30 z-0" />
            </div>
          </div>
        </div>
      </div>
    </section>);

}